module.exports = __webpack_public_path__ + "33b95c87f5433a89d7078c9f0d12374b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ms-bg-1.jpg
// module id = 144
// module chunks = 0